/**
 * Workspace limits — free vs Pro (enforced server-side).
 *
 * **User vocabulary:** folder = fan card on Home; note = card inside a folder (or Home).
 * **Sections:** blocks inside a note when editing (same cap Free + Pro today).
 *
 * @see docs/pricing-free-vs-pro.md
 */

/** Shared editor cap (Free + Pro) — max sections inside one note. */
export const MAX_SECTIONS_PER_NOTE = 20;

/** @deprecated Use MAX_SECTIONS_PER_NOTE */
export const MAX_SECTIONS_PER_NOTEBOOK = MAX_SECTIONS_PER_NOTE;

/** Free tier */
export const FREE_TIER_MAX_WORKSPACES = 1;
export const FREE_TIER_MAX_FOLDERS = 5;
export const FREE_TIER_MAX_SCROLLS_PER_FOLDER = 3;
export const FREE_TIER_MAX_PUBLISHED = 2;
/** Free tier — starred/favorite notes across the account. */
export const FREE_TIER_MAX_STARRED_NOTES = 10;
/** Internal only — direct note create API (not marketed as “notebook slots”). */
export const FREE_TIER_MAX_NOTEBOOKS = 3;

/** Pro tier */
export const PRO_TIER_MAX_WORKSPACES = 3;
export const PRO_TIER_MAX_FOLDERS = 10;
export const PRO_TIER_MAX_SCROLLS_PER_FOLDER = 8;
export const PRO_TIER_MAX_PUBLISHED = 10;
/** Internal only — direct note create API. */
export const PRO_TIER_MAX_NOTEBOOKS = 10;

/** @deprecated Use MAX_SECTIONS_PER_NOTE */
export const FREE_TIER_MAX_NOTES_PER_NOTEBOOK = MAX_SECTIONS_PER_NOTE;

/** API + client: stable codes for upgrade UX and analytics. */
export type PlanLimitErrorCode =
  | "FREE_WORKSPACE_LIMIT"
  | "FREE_FOLDER_LIMIT"
  | "FREE_NOTEBOOK_LIMIT"
  | "FREE_NOTE_LIMIT"
  | "FREE_PUBLISH_LIMIT"
  | "FREE_STAR_LIMIT"
  | "PLAN_READ_ONLY";

export function maxWorkspacesForPlan(isPro: boolean): number {
  return isPro ? PRO_TIER_MAX_WORKSPACES : FREE_TIER_MAX_WORKSPACES;
}

export function maxSectionsPerNoteForPlan(_isPro: boolean): number {
  return MAX_SECTIONS_PER_NOTE;
}

/** @deprecated Use maxSectionsPerNoteForPlan */
export function maxSectionsPerNotebookForPlan(isPro: boolean): number {
  return maxSectionsPerNoteForPlan(isPro);
}

export function maxNotebooksForPlan(isPro: boolean): number {
  return isPro ? PRO_TIER_MAX_NOTEBOOKS : FREE_TIER_MAX_NOTEBOOKS;
}

/** @deprecated Prefer maxSectionsPerNotebookForPlan */
export function maxNotesPerNotebookForPlan(isPro: boolean): number | null {
  return maxSectionsPerNotebookForPlan(isPro);
}

export function maxFoldersForPlan(isPro: boolean): number {
  return isPro ? PRO_TIER_MAX_FOLDERS : FREE_TIER_MAX_FOLDERS;
}

export function maxScrollsPerFolderForPlan(isPro: boolean): number {
  return isPro
    ? PRO_TIER_MAX_SCROLLS_PER_FOLDER
    : FREE_TIER_MAX_SCROLLS_PER_FOLDER;
}

export function maxPublishedForPlan(isPro: boolean): number {
  return isPro ? PRO_TIER_MAX_PUBLISHED : FREE_TIER_MAX_PUBLISHED;
}

/** `null` = unlimited (Pro). */
export function maxStarredNotesForPlan(isPro: boolean): number | null {
  return isPro ? null : FREE_TIER_MAX_STARRED_NOTES;
}
